import {useState} from "react";
import moment from "moment/moment";
import {DATE_FORMAT_POINT_SINGLE_VOYAGE} from "@containers/singleVoyage/containers/points/constants/dateFormat";
import {IWayPointCreationSingleVoyage} from "@containers/singleVoyage/types/point";
import {IStateMutatePointMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/points/mutatePoint/types";

export function useGetStateMutatePointMutateSingleVoyage({
                                                             initial
                                                         }: {
    initial?: IWayPointCreationSingleVoyage,
}): IStateMutatePointMutateSingleVoyage {

    const [name, setName] = useState<string>(initial?.name ?? '')
    const [address, setAddress] = useState<string>(initial?.address ?? '')
    const [radius, setRadius] = useState<string>(initial?.radius?.toString() ?? '')
    const [hasPlannedDeparture, setHasPlannedDeparture] = useState<boolean>(!!initial?.plannedDeparture)
    const [plannedDeparture, setPlannedDeparture] = useState<string | null>(initial?.plannedDeparture ? moment(initial?.plannedDeparture).format(DATE_FORMAT_POINT_SINGLE_VOYAGE) : null)
    const [hasPlannedArrival, setHasPlannedArrival] = useState<boolean>(!!initial?.plannedArrival)
    const [plannedArrival, setPlannedArrival] = useState<string | null>(initial?.plannedArrival ? moment(initial?.plannedArrival).format(DATE_FORMAT_POINT_SINGLE_VOYAGE) : null)


    return {
        name,
        onChangeName: setName,
        address,
        onChangeAddress: setAddress,
        radius,
        onChangeRadius: setRadius,
        hasPlannedDeparture,
        onChangeHasPlannedDeparture: setHasPlannedDeparture,
        plannedDeparture,
        onChangePlannedDeparture: setPlannedDeparture,
        hasPlannedArrival,
        onChangeHasPlannedArrival: setHasPlannedArrival,
        plannedArrival,
        onChangePlannedArrival: setPlannedArrival,
    }
}